var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.92969 2.92892C3.85831 2.00033 4.96075 1.26374 6.17406 0.7612C7.38736 0.258656 8.68778 -1.39397e-07 10.0011 0C11.3143 1.39397e-07 12.6147 0.258657 13.828 0.761201C15.0414 1.26375 16.1438 2.00034 17.0724 2.92892C18.001 3.8575 18.7377 4.95988 19.2402 6.17313C19.7428 7.38638 20.0015 8.68673 20.0015 9.99995C20.0015 11.3132 19.7428 12.6135 19.2402 13.8268C18.7377 15.04 18.001 16.1424 17.0724 17.071L2.92969 2.92892Z",
    fill: "#FF6161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.3443 15.6568C7.46863 18.7809 12.5342 18.7809 15.6585 15.6568C18.7828 12.5326 18.7828 7.4673 15.6585 4.34312C12.5342 1.21894 7.46863 1.21894 4.3443 4.34312C1.21998 7.4673 1.21998 12.5326 4.3443 15.6568ZM2.93003 17.071C6.83544 20.9762 13.1674 20.9762 17.0728 17.071C20.9782 13.1658 20.9782 6.83414 17.0728 2.92892C13.1674 -0.976305 6.83544 -0.976305 2.93003 2.92892C-0.975375 6.83414 -0.975375 13.1658 2.93003 17.071Z",
    fill: "#3D0E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0655 6.93562C13.4561 7.32614 13.4561 7.9593 13.0655 8.34982L8.35129 13.0638C7.96075 13.4544 7.32756 13.4544 6.93702 13.0638C6.54648 12.6733 6.54648 12.0402 6.93702 11.6496L11.6513 6.93562C12.0418 6.5451 12.675 6.5451 13.0655 6.93562Z",
    fill: "#3D0E6B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0653 13.0635C12.6748 13.4541 12.0416 13.4541 11.6511 13.0635L6.93681 8.34953C6.54627 7.95901 6.54627 7.32585 6.93681 6.93532C7.32735 6.5448 7.96054 6.5448 8.35108 6.93532L13.0653 11.6493C13.4559 12.0399 13.4559 12.673 13.0653 13.0635Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseError);
export default __webpack_public_path__ + "static/media/close-error.7b4fece47d28e6c1201f7aba071e8788.svg";
export { ForwardRef as ReactComponent };